import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";

export default function getSingleAndReturnAmenities(pairedAmenityGroups: PairedSingleAndReturnAmenitiesType) {
    const {
        returnGroup,
        singleGroup,
    } = pairedAmenityGroups

    const {amenities: singleAmenities} = singleGroup || {}
    const {amenities: returnAmenities} = returnGroup || {}

    return {
        singleAmenities,
        returnAmenities,
    }
}